import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import GenericMasterProfile from "../screens/masters/genericmaster/GenericMasterProfile";
import queryString from "query-string";

const Home = props => {
  const values = queryString.parse(props.location.search);
  const breadCrumbData = [
    { link: "/masters-list", name: "Masters" },
    { link: "/master-profile", name: "Generic Master" },
    {
      link: `/genericmaster-list?id=${values.masterFor}&name=${values.name}`,
      name: values.name
    },
    { link: "/genericmaster-edit", name: `${values.name} Profile` }
  ];
  return (
    <>
      <LayoutContainer>
        <BreadCrumb data={breadCrumbData} />
        <GenericMasterProfile />
      </LayoutContainer>
    </>
  );
};
export default Home;
